import { render, staticRenderFns } from "./Index.page.vue?vue&type=template&id=cf7de1ce&scoped=true&"
import script from "./Index.page.vue?vue&type=script&lang=js&"
export * from "./Index.page.vue?vue&type=script&lang=js&"
import style0 from "./Index.page.vue?vue&type=style&index=0&id=cf7de1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7de1ce",
  null
  
)

export default component.exports